var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-form-field',{attrs:{"inline":""}},[_c('label',[_vm._v(_vm._s(_vm.QuestionNumber)+". "+_vm._s(_vm.Label))]),_vm._v(" "+_vm._s(_vm.ComputedValue)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }